export const createOrganizationFrag = `
    id
`;
